import * as React from 'react';
import logo from '../img/logo.svg';
import { Box, AppBar, Toolbar, styled } from '@mui/material';

const Logo = styled('div')(() => ({
    display: "block",
    verticalAlign: "middle",
    height: 0,
    width: 160,
    marginTop: "-0.25rem",
    padding: "28.5714% 0 0",
    background: `url(${logo}) no-repeat center center/contain`
}));

export default function Header() {

    return (
        <Box mb={3}>
            <AppBar position="static" color="secondary">
                <Toolbar>
                    <a href="/">
                        <Logo />
                    </a>
                </Toolbar>
            </AppBar>
        </Box>
    )
}
